// extracted by mini-css-extract-plugin
export default {"mygraph":"BarGraph_mygraph__sXgJr"};